import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface SelectedPlatform {
  slug: string;
  platformId: number;
  name: string;
}

interface TrackingStore {
  selectedPlatforms: SelectedPlatform[];
  pendingNewPlatforms: SelectedPlatform[];
  setSelectedPlatforms: (platforms: SelectedPlatform[]) => void;
  addPlatform: (platform: SelectedPlatform) => void;
  removePlatform: (slug: string) => void;
  clearPlatforms: () => void;
  addPendingPlatform: (platform: SelectedPlatform) => void;
  clearPendingPlatforms: () => void;
}

export const useTrackingStore = create<TrackingStore>()(
  devtools(
    (set) => ({
      selectedPlatforms: [],
      pendingNewPlatforms: [],

      setSelectedPlatforms: (platforms) =>
        set({ selectedPlatforms: platforms }, false, 'setSelectedPlatforms'),

      addPlatform: (platform) =>
        set((state) => ({
          selectedPlatforms: [...state.selectedPlatforms, platform]
        }), false, 'addPlatform'),

      removePlatform: (slug) =>
        set((state) => ({
          selectedPlatforms: state.selectedPlatforms.filter(p => p.slug !== slug)
        }), false, 'removePlatform'),

      clearPlatforms: () =>
        set({ selectedPlatforms: [] }, false, 'clearPlatforms'),

      addPendingPlatform: (platform) =>
        set((state) => ({
          pendingNewPlatforms: [...state.pendingNewPlatforms, platform]
        }), false, 'addPendingPlatform'),

      clearPendingPlatforms: () =>
        set({ pendingNewPlatforms: [] }, false, 'clearPendingPlatforms'),
    }),
    { name: 'tracking-store' }
  )
);
